var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddBudgetItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M4.375 14.2026C4.375 10.4314 4.375 8.54578 5.54657 7.37421C6.71815 6.20264 8.60376 6.20264 12.375 6.20264H22.375C26.1462 6.20264 28.0319 6.20264 29.2034 7.37421C30.375 8.54578 30.375 10.4314 30.375 14.2026V24.2026C30.375 27.9739 30.375 29.8595 29.2034 31.0311C28.0319 32.2026 26.1462 32.2026 22.375 32.2026H12.375C8.60376 32.2026 6.71815 32.2026 5.54657 31.0311C4.375 29.8595 4.375 27.9739 4.375 24.2026V14.2026Z",
    stroke: "var(--stak-dark-green)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 52",
    d: "M17.5 13.2974L17.5 24.6487",
    stroke: "var(--stak-dark-green)",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 53",
    d: "M23.333 18.9729L11.6663 18.9729",
    stroke: "var(--stak-dark-green)",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBudgetItem);
export default __webpack_public_path__ + "static/media/AddBudgetItem.b7415b920f8754c2e0f05de4aa2c860e.svg";
export { ForwardRef as ReactComponent };